import React, { useState, useEffect } from 'react';
import ModalBox from '../ModalBox/ModalBox';
import "./NewPackoutBox.css";

export default function NewPackoutBox({ open, onClose, onSubmit }) {
  const [name, setName] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      localStorage.setItem('packoutname', name);
    }
    window.location.href = "#/uploadFilePage";
  };

  const cancel =()=>{
    window.location.href = "#/"
  }

  useEffect(() => {
    setName(""); // reset every time the modal opens
  }, [open]);

  return (
    <ModalBox open={open} onClose={onClose} title="New Packout" className="new-box" disableBackdrop={true} hideCloseButton={true}>
      <p className="semibold">You are about to create a new packout!</p>
      <p>Please choose a name that will help you identify this file across all steps, exports, and tracking.
      </p>
      <form onSubmit={handleSubmit} className="new-box-form">
        <fieldset>
            <legend>Packout Name</legend>
            <input
            type="text"
            placeholder="ex. PKT-20240710-0010"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </fieldset>

        <div className="form-actions">
          <button className="white-button" type="button" onClick={()=>cancel()}>Cancel</button>
          <button className="blue-button" disabled={name.trim() === ""} type="submit">Create & Continue</button>
        </div>
      </form>
    </ModalBox>

  );
}